import { render, staticRenderFns } from "./UsersGroups.vue?vue&type=template&id=4e46daf8&"
import script from "./UsersGroups.vue?vue&type=script&lang=js&"
export * from "./UsersGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports